import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import Link from "next/link";
import { Typography } from "@mui/material";
import { ListingType } from "../../../../../enums/listing/TitleTypes";
import { setTabSection } from "../../../../../redux/pages/exploreSlice";

export const ListingHeaderLink = () => {
  const listingType = useSelector(
    (state: RootState) => state.trainingPlan.listingType,
  );
  const theme = useSelector((state: RootState) => state.theme);
  const dispatch = useDispatch();

  return (
    <Link
      onClick={() => {
        if (listingType === ListingType.TRAINING_PLAN) {
          dispatch(setTabSection(0));
        }

        if (listingType === ListingType.WORKOUT) {
          dispatch(setTabSection(2));
        }
      }}
      href={listingType === ListingType.BLOG ? "/blog" : "/explore"}
    >
      <Typography
        sx={{
          color: theme.componentColors.primary.primary,
        }}
        className="text-[16px]  "
        variant="h2"
      >
        {listingType}s
      </Typography>
    </Link>
  );
};
